// // Firestore + Storage CRUD для "Комерційних новин"
// import {
//   addDoc,
//   collection,
//   deleteDoc,
//   doc,
//   getDoc,
//   getDocs,
//   limit,
//   onSnapshot,
//   orderBy,
//   query,
//   serverTimestamp,
//   setDoc,
//   updateDoc,
//   where,
//   startAt,
//   endAt,
// } from "firebase/firestore";
// import {
//   getDownloadURL,
//   ref,
//   uploadBytes,
//   deleteObject,
// } from "firebase/storage";
// import { db, storage } from "../firebase";

// // ======= МОДЕЛЬ ДАНИХ =======
// // commercialNews (collection)
// //  - id (doc id)
// //  - title (string) — заголовок
// //  - subtitle (string) — підзаголовок/короткий опис
// //  - bodyHtml (string, optional) — розширений текст (не обов’язково)
// //  - imageUrl (string) — картинка банера
// //  - imageAlt (string)
// //  - linkedProduct: { uid: string, bookName: string, slug: string } — денорм
// //  - ctaText (string) — текст кнопки (наприклад "Детальніше")
// //  - active (boolean)
// //  - pinned (boolean) — піднімати вище
// //  - weight (number) — ручне сортування (чим більше — тим вище)
// //  - startAt, endAt (timestamp | null) — період показу (опціонально)
// //  - createdAt, updatedAt (timestamp)

// // ======= HELPERS =======
// export function newsDocRef(id) {
//   return doc(db, "commercialNews", id);
// }
// export function newsColRef() {
//   return collection(db, "commercialNews");
// }

// // пошук книги за назвою (потрібен індекс або поле bookNameLower у product)
// export async function searchProductsByName(term, limitN = 10) {
//   const t = (term || "").trim().toLowerCase();
//   if (!t) return [];
//   try {
//     // якщо маєте поле bookNameLower
//     const q1 = query(
//       collection(db, "product"),
//       orderBy("bookNameLower"),
//       startAt(t),
//       endAt(t + "\uf8ff"),
//       limit(limitN)
//     );
//     const snap1 = await getDocs(q1);
//     if (!snap1.empty) {
//       return snap1.docs.map((d) => ({ id: d.id, ...d.data() }));
//     }
//   } catch (_) {}

//   // фолбек: забрати частину колекції й профільтрувати на клієнті
//   const q2 = query(collection(db, "product"), limit(limitN * 5));
//   const snap2 = await getDocs(q2);
//   const arr = snap2.docs.map((d) => ({ id: d.id, ...d.data() }));
//   return arr
//     .filter((p) =>
//       (p.bookName || "").toLowerCase().includes((term || "").toLowerCase())
//     )
//     .slice(0, limitN);
// }

// // створення новини
// export async function createNews(payload, file) {
//   const col = newsColRef();
//   const docRef = await addDoc(col, {
//     ...payload,
//     active: !!payload.active,
//     pinned: !!payload.pinned,
//     weight: Number(payload.weight || 0),
//     createdAt: serverTimestamp(),
//     updatedAt: serverTimestamp(),
//   });

//   let imageUrl = payload.imageUrl || "";
//   if (file) {
//     const storageRef = ref(storage, `commercialNews/${docRef.id}/${file.name}`);
//     await uploadBytes(storageRef, file);
//     imageUrl = await getDownloadURL(storageRef);
//     await updateDoc(docRef, { imageUrl });
//   }
//   return docRef.id;
// }

// // оновлення новини
// export async function updateNews(id, patch, file, opts = { deleteOld: false }) {
//   const refDoc = newsDocRef(id);
//   const snap = await getDoc(refDoc);
//   if (!snap.exists()) throw new Error("Новину не знайдено");

//   let imageUrl = patch.imageUrl ?? snap.data().imageUrl ?? "";

//   if (file) {
//     // видалити старий файл (опціонально)
//     if (opts.deleteOld && imageUrl) {
//       try {
//         const oldRef = ref(storage, imageUrl);
//         await deleteObject(oldRef);
//       } catch (_) {}
//     }
//     const storageRef = ref(storage, `commercialNews/${id}/${file.name}`);
//     await uploadBytes(storageRef, file);
//     imageUrl = await getDownloadURL(storageRef);
//   }

//   await updateDoc(refDoc, {
//     ...patch,
//     imageUrl,
//     updatedAt: serverTimestamp(),
//   });
// }

// // видалення новини
// export async function removeNews(id) {
//   const refDoc = newsDocRef(id);
//   await deleteDoc(refDoc);
// }

// // підписка на всі новини (для адмінки)
// export function subscribeAllNews(cb) {
//   const q = query(
//     newsColRef(),
//     orderBy("pinned", "desc"),
//     orderBy("weight", "desc"),
//     orderBy("createdAt", "desc")
//   );
//   return onSnapshot(q, (snap) => {
//     cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
//   });
// }

// // підписка на активні (для фронту)
// export function subscribeActiveNews(cb) {
//   const q = query(
//     newsColRef(),
//     where("active", "==", true),
//     orderBy("pinned", "desc"),
//     orderBy("weight", "desc"),
//     orderBy("createdAt", "desc")
//   );
//   return onSnapshot(q, (snap) => {
//     const now = Date.now();
//     const arr = snap.docs
//       .map((d) => ({ id: d.id, ...d.data() }))
//       .filter((n) => {
//         const s = n.startAt?.toMillis?.() ?? 0;
//         const e = n.endAt?.toMillis?.() ?? Infinity;
//         return now >= s && now <= e;
//       });
//     cb(arr);
//   });
// }
// services/commercialNewsService.js
// services/commercialNewsService.js
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  limit as qlimit,
  startAt,
  endAt,
  limit,
} from "firebase/firestore";
import { db, storage } from "../firebase"; // переконайся, що storage ініціалізовано
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const COL = "commercialNews"; // <-- перевір, що саме так названа колекція
const PRODUCTS_COL = "product"; // <-- і що так називається колекція товарів

/* ========= helpers ========= */
async function uploadImageIfAny(file) {
  if (!file) return null;
  const ext = file.name?.split(".").pop() || "jpg";
  const r = ref(storage, `commercialNews/${Date.now()}.${ext}`);
  await uploadBytes(r, file);
  return await getDownloadURL(r);
}

/* ========= CRUD ========= */
export async function createNews(draft, file = null) {
  const imageUrl = await uploadImageIfAny(file);
  const payload = {
    title: draft.title || "",
    subtitle: draft.subtitle || "",
    bodyHtml: draft.bodyHtml || "",
    imageUrl: imageUrl || draft.imageUrl || "",
    imageAlt: draft.imageAlt || "",
    linkedProduct: draft.linkedProduct || null, // {uid, bookName, slug}
    ctaText: draft.ctaText || "Детальніше",
    active: draft.active ?? true,
    pinned: draft.pinned ?? false,
    weight: Number(draft.weight || 0),
    startAt: draft.startAt || null, // можна зберігати як Timestamp/ISO
    endAt: draft.endAt || null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  await addDoc(collection(db, COL), payload);
}

export async function updateNews(id, patch, file = null) {
  const refDoc = doc(db, COL, id);
  const out = { ...patch, updatedAt: serverTimestamp() };
  if (file) {
    const nextUrl = await uploadImageIfAny(file);
    if (nextUrl) out.imageUrl = nextUrl;
  }
  await updateDoc(refDoc, out);
}

export async function removeNews(id) {
  await deleteDoc(doc(db, COL, id));
}

/* ========= SUBSCRIPTIONS ========= */
// Адмінський список — простий orderBy(createdAt) без складних індексів
export function subscribeAllNews(cb) {
  const qRef = query(collection(db, COL), orderBy("createdAt", "desc"));
  return onSnapshot(
    qRef,
    (snap) => {
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      cb(items);
    },
    (err) => {
      console.error("[commercialNews] subscribeAllNews error:", err);
      cb([]); // щоб UI не зависав
    }
  );
}

// На головну (активні із вікном публікації, pinned/weight — якщо треба)

export function subscribeActiveNews(cb, { take = 5 } = {}) {
  const qRef = query(collection(db, COL), orderBy("createdAt", "desc"));

  const toMs = (v) =>
    v && typeof v.toMillis === "function"
      ? v.toMillis()
      : v
      ? new Date(v).getTime()
      : null;

  return onSnapshot(
    qRef,
    (snap) => {
      const now = Date.now();
      let items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      // фільтрація на клієнті (щоб не вимагало індекс)
      items = items.filter((it) => {
        const started = !it.startAt || toMs(it.startAt) <= now;
        const notEnded = !it.endAt || toMs(it.endAt) >= now;
        return !!it.active && started && notEnded;
      });

      // pinned → weight → createdAt
      items.sort((a, b) => {
        if (!!a.pinned !== !!b.pinned)
          return Number(b.pinned) - Number(a.pinned);
        const wA = Number(a.weight || 0);
        const wB = Number(b.weight || 0);
        if (wA !== wB) return wB - wA;
        const ca = toMs(a.createdAt) || 0;
        const cb = toMs(b.createdAt) || 0;
        return cb - ca;
      });

      if (take > 0) items = items.slice(0, take);
      cb(items);
    },
    (err) => {
      console.error("[commercialNews] subscribeActiveNews error:", err);
      cb([]);
    }
  );
}

/* ========= SEARCH PRODUCTS ========= */

export async function searchProductsByName(qText, take = 20) {
  const qStr = (qText || "").trim();
  if (!qStr) return [];
  const qRef = query(
    collection(db, "product"),
    orderBy("bookName"),
    startAt(qStr),
    endAt(qStr + "\uf8ff"),
    limit(take)
  );
  const snap = await getDocs(qRef);
  return snap.docs.map((d) => ({ id: d.id, uid: d.id, ...d.data() }));
}
